import { render, staticRenderFns } from "./ExternalizationsSection.vue?vue&type=template&id=26fa0d70"
import script from "./ExternalizationsSection.vue?vue&type=script&lang=js"
export * from "./ExternalizationsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports